// extracted by mini-css-extract-plugin
module.exports = {"gridForm":"ColumnMapping_gridForm__31Hb6"};